import React from 'react';
import ReactMarkdown from 'react-markdown';
import {CardContent} from '../card';
import {Button, IButtonProps} from '../button';
import {getTooltipButton} from '../button/button';

export interface IWeeklyRetroCardProps {
    title: string;
    businessUnitName?: string;
    analysis: string;
    close: IButtonProps;
    email: IButtonProps;
    copy: IButtonProps;
}

const WeeklyRetroCard = (props: IWeeklyRetroCardProps): JSX.Element => (
    <CardContent>
        <div className="text text--double">
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div>
                    <h3 style={{color: '#FFC212'}}>{props.title}</h3>
                    {props.businessUnitName && <small>{props.businessUnitName}</small>}
                </div>
                <div className="button-container">
                    {getTooltipButton({...props.copy, color: 'white', icon: 'layers'})}
                    {getTooltipButton({...props.email, color: 'white', icon: 'mail-out'})}
                    <Button {...props.close} color="white" icon="close" style="link" />
                </div>
            </div>
            <ReactMarkdown>{props.analysis}</ReactMarkdown>
        </div>
    </CardContent>
);

export default WeeklyRetroCard;
